const DATE_FILTERS = {
  THREE_MONTHS: '', //Default
  TWELVE_MONTHS: '12months',
  CUSTOM_DATE: 'custom-date'
}

export default DATE_FILTERS
